import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'pvmo-page',
  imports: [],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponent {}
